<template>
  <div class="grid">
    <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />

        <div class="p-fluid formgrid grid" style="margin-top: 2%">

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" v-model="stop_name" /><label for="stop_name">Stop name</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" v-model="route_name" /><label for="route_name">Route name</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" v-model="person_name" /><label for="person_name">Person name</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText maxlength="10" type="text" v-model="person_mobile" onkeypress="return event.charCode>=48 && event.charCode<=57" />
              <label for="person_mobile">Person mobile</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="user_key && (client_group_ids)">
            <span class="p-float-label">
              <Dropdown id="state" filter v-model="client_id_search" :options="client_id_dropdown"
                optionLabel="name" :optionValue="code" @change="get_vehicle_type_master"></Dropdown>
              <label>Select Client</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <MultiSelect id="User" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                optionLabel="name" @change="getBlockData">
              </MultiSelect>
              <label for="complaint_status">District</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <MultiSelect id="User" filter v-model="block_dropdownItem" :options="block_dropdownItems" optionLabel="name"
              :loading="set_loading" @change="getPanchayatData">
              </MultiSelect>
              <label for="complaint_status">Block</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <MultiSelect id="Panchayat" filter v-model="panchayat_dropdownItem" :options="panchayat_dropdownItems" optionLabel="name"
                 :loading="set_loading" @change="get_village(1)">
              </MultiSelect>
              <label for="complaint_status">Panchayat</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <MultiSelect v-model="village_dropdownItem" :options="village_dropdownItems" optionLabel="name" filter
              display="chip" @filter="get_village" placeholder="Village">
            </MultiSelect>
          </div>

          <div class="field col-12 md:col-2">
            <Button v-if="!showFirstFilter" style="color: white; background: 
        lightgreen; border: none" icon="pi pi-ellipsis-h" @click="show_filter()" v-tooltip.bottom="'more'"/>&nbsp;
            <Button icon="pi pi-search" v-tooltip.bottom="'Search'" @click="search(1)" />&nbsp;
            <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
            <!-- <button v-if="!showFirstFilter" style="color: blue; background: none; border: none" @click="show_filter()">
              more ...
            </button> -->
            
          </div>
        </div>

        <DataTable :loading="loading" ref="dt" :lazy="true" :totalRecords="totalRecords" :paginator="true"
          :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit" :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
          style="font-size: 12px" :rowHover="true" showGridlines>
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <h5 class="m-0"><b> Commercial Master</b></h5>
              <!-- Total Records:{{totalRecords}} -->
              <div>
             
              <Button  class="ml-2" 
                  v-tooltip.bottom="'Generate QR'" @click="GenerateQr" >Generate QR</Button>
                
               </div>
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total Stops:</span>{{ totalRecords }}
            </div>
            <div style="text-align: left;">
                                <Button :disabled="selectedProducts.length == 0" label="Print QR" size="small"
                                    severity="warning" raised @click="Print_QR_selected()"
                                    v-tooltip.bottom="'Print QR'" />
                            </div>
          </template>
          <!-- <Column header="Action" headerStyle="min-width:13rem;">
                <template #body="slotProps">
                  <Button
                    icon="pi pi-eye"
                    v-tooltip.bottom="'View'"
                    class="p-button-rounded p-button-warning mr-2"
                    @click="viewProduct(slotProps.data)"
                    size="small"
                  />
                  <Button
                    v-if="slotProps.data.complaint_status_name!='Closed'"
                    v-tooltip.bottom="'Update'"
                    class="p-button-rounded p-button-success mr-2"
                    @click="editProduct(slotProps.data)"
                    label="Update"
                    size="small"
                  />
                </template>
              </Column> -->
              <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
              <Column header="QR" :field="columns[1]" style="min-width: 5rem">
            <template #body="{ data }">
              <Button
                icon="pi pi-bookmark"
                class="p-button-rounded p-button-primary mt-2"
                v-tooltip.bottom="'QR Code'"
                v-if="data.status=='Active' || data.status=='active'"
                @click="showQr(data)"
              />
            </template>
          </Column>
          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="Status" style="min-width: 8rem; text-align: center" :field="columns[5]">
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'">
                <badge :value="data.status" severity="success"></badge>
              </span>
              <span v-else-if="data.status == 'InActive' || data.status == 'In Active'
                ">
                <badge :value="data.status" severity="warning"></badge>
              </span>
              <span v-else-if="data.status == 'Delete' || data.status == 'Deleted'">
                <badge :value="data.status" severity="danger"></badge>
              </span>
              <span v-else>-</span>
            </template>
          </Column>
         
        
          <Column header="Stop Name" :field="columns[1]" style="min-width: 10rem">
            <template #body="{ data }">
              {{ data.stop_name }}
            </template>
          </Column>
          <Column header="Person Name" :field="columns[1]" style="min-width: 10rem">
            <template #body="{ data }">
              {{ data.person_name }}
            </template>
          </Column>
          <Column header="Mobile" :field="columns[1]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.person_mobile }}
            </template>
          </Column>
          <Column header="Route Name" :field="columns[1]" style="min-width: 10rem">
            <template #body="{ data }">
              <span>{{ data.route_name }}</span>
            </template>
          </Column>
          <!-- <Column
              header="Village Code"
              :field="columns[1]"
              style="min-width: 10rem"
            >
              <template #body="{ data }">
                {{ data.village_code }}
              </template>
            </Column> -->
          <!-- <Column
              header="Village Name"
              :field="columns[1]"
              style="min-width: 15rem"
            >
              <template #body="{ data }">
                {{ data.village_code }} - {{ data.village_name }}
              </template>
            </Column> -->
            <Column
              header="District Name"
              :field="columns[2]"
              style="min-width: 15rem"
            >
              <template #body="{ data }">
                {{ data.district_code }} - {{ data.district_name }}
              </template>
            </Column>
          <!-- <Column
              header="Block Code"
              :field="columns[2]"
              style="min-width: 10rem"
            >
              <template #body="{ data }">
                {{ data.block_code }}
              </template>
            </Column> -->
          <Column
              header="Block Name"
              :field="columns[2]"
              style="min-width: 15rem"
            >
              <template #body="{ data }">
                {{ data.block_code }} - {{ data.block_name }}
              </template>
            </Column>
          <!-- <Column
              header="State Code"
              :field="columns[2]"
              style="min-width: 10rem"
            >
              <template #body="{ data }">
                {{ data.state_code }}
              </template>
            </Column> -->
          <!-- <Column
              header="State Name"
              :field="columns[2]"
              style="min-width: 15rem"
            >
              <template #body="{ data }">
                {{ data.state_code }} - {{ data.state }}
              </template>
            </Column> -->
        </DataTable>
        <Dialog v-model:visible="print_QR_Model" :style="{ width: '500px' }" header="Delivery Chalan"
                        :modal="true">
          <div style="text-align: right">
            <Button icon="pi pi-file-pdf" @click="print_Qr()" class="p-button-rounded p-button-info mr-2 mb-2"/>
          </div>
          <div id="printMe" style="margin-top: 20px;margin-bottom:20px;margin-left: 20px;margin-right:20px;font-family: Arial, Helvetica, sans-serif;">
            <div v-for="(result, key) in printQR_data" :key="key" style="page-break-after: always !important;">
              <span><b>Route Name :</b>  {{ result.data.route_name }}</span><br>
              <span><b>Stop Name :</b> {{ result.data.stop_name }}</span>
              <qrcode-vue :id="'qrprint_' + result.data.uicode" type="image/png" style="width:100%"  :value="result.data.uicode" size="450" level="H" />
              <hr class="new">
            </div>
          </div>
        </Dialog>
        <Sidebar v-model:visible="productDialog" :baseZIndex="1000" position="full">
          <div class="col-12">
            <div class="card">
              <h5>Complaint Details</h5>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="complaint_id" type="text" v-model.trim="product.complaint_id" required="true" autofocus
                      disabled :class="{ 'p-invalid': submitted && !product.complaint_id }" />
                    <label for="complaint_id">Complaint ID</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="complaint_by_name" type="text" v-model.trim="product.complaint_by_name" required="true"
                      autofocus disabled :class="{ 'p-invalid': submitted && !product.complaint_by_name }" />
                    <label for="complaint_by_name">Complaint By</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="complaint_by_contact" type="text" v-model.trim="product.complaint_by_contact"
                      required="true" autofocus disabled
                      :class="{ 'p-invalid': submitted && !product.complaint_by_contact }" />
                    <label for="complaint_by_contact">Mobile</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="complaint_date" type="text" v-model.trim="product.complaint_date" required="true"
                      autofocus disabled :class="{ 'p-invalid': submitted && !product.complaint_date }" />
                    <label for="complaint_date">Complaint Date</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <Dropdown display="chip" id="User" filter v-model="complaint_type_get"
                      :options="stop_type_dropdownItems" optionLabel="name" disabled>
                    </Dropdown>
                    <label for="complaint_status">Complaint Type</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="village_name" type="text" v-model.trim="product.village_name" required="true" autofocus
                      disabled :class="{ 'p-invalid': submitted && !product.village_name }" />
                    <label for="village_name">Village</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="block_name" type="text" v-model.trim="product.block_name" required="true" autofocus
                      disabled :class="{ 'p-invalid': submitted && !product.block_name }" />
                    <label for="block_name">Block</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="district_name" type="text" v-model.trim="product.district_name" required="true"
                      autofocus disabled :class="{ 'p-invalid': submitted && !product.district_name }" />
                    <label for="district_name">District</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="state" type="text" v-model.trim="product.state" required="true" autofocus disabled
                      :class="{ 'p-invalid': submitted && !product.state }" />
                    <label for="state">State</label>
                  </span>
                </div>
              </div>
              <hr>
              <div class="p-fluid formgrid grid">
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <Dropdown display="chip" id="User" filter v-model="complaint_status_get"
                      :options="stop_status_dropdownItems" optionLabel="name" :disabled="show == false">
                    </Dropdown>
                    <label for="complaint_status">Complaint Status <b style="color:red">*</b></label>
                  </span>
                </div>
                <div class="field col-6 md:col-9" style="margin-top: 1%;">
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <Textarea inputId="remark" rows="3" cols="30" v-model="product.remark"
                      :disabled="show == false"></Textarea>
                    <label for="remark">Remark <b style="color:red">*</b></label>
                  </span>
                </div>
                <div class="field col-12 md:col-10" style="margin-top: 1%;"></div>
                <div class="field col-12 md:col-2" style="margin-top: 1%;"><Button v-if="product._id && show == true"
                    label="Save" @click="update_complaint" class="p-button-success" /></div>
              </div>
            </div>
          </div>
        </Sidebar>
        <Dialog
          v-model:visible="qrCodetDialog"
          :style="{ width: '450px' }"
          header="QR Code"
          :modal="true"
        >
        <div style="text-align:right">
          <Button  icon="pi pi-print" @click="printQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
          <Button  icon="pi pi-download" @click="downloadQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
        </div>
				<br>
        <div>
              <qrcode-vue id="qrprint" type="image/png" style="width:100%"  :value="qrcodevalue" size="450" level="H" />
        </div>
        </Dialog>
        <Dialog v-model:visible="generateQRDialog" :style="{ width: '650px' }" header="Generate QR" :modal="true">
          <div class="p-fluid formgrid grid" style="margin-top: 10%">
            <div class="field col-12 md:col-6">
            <span class="p-float-label">
              <!--  <Dropdown  id="state" filter
                v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="code"
                ></Dropdown> -->
                <Dropdown id="Panchayat" filter v-model="panchayat_dropdownItem_select" :options="panchayat_dropdownItems" optionLabel="name"
                  @filter="getPanchayatData($event.value)">
              </Dropdown>
              <label>Select Panchyat</label>
            </span>
          </div>
            
            <div class="field col-12 md:col-6">
            <span class="p-float-label">
              <InputText format="text" v-model="qrCount"> </InputText>
              <label>Total no of QR</label>
            </span>
          </div>
          
            </div>
          <template #footer>
            <Button label="Generate QR" class="p-button-text " style="background-color: 
#d6ebf9; border: 1px solid #246D9F;" @click="generate_QR" ></Button>
            <!-- <label>Generate QR</label> -->
            <!-- <Button  class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;"
            v-tooltip.bottom="'Generate QR'" @click="generate_QR" >Generate QR</Button> -->
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import QrcodeVue from 'qrcode.vue'
import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
import { jsPDF } from "jspdf";
//import FormNewsMaster from "@/components/FormNewsMaster";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
export default {
  data() {
    return {
      panchayat_dropdownItem_select:'',
      generateQRDialog:false,
      qrCount:'',
      print_stop_name:"",
      print_route_name:"",
      qrcodevalue:"123444",
      qrCodetDialog:false,
      print_QR_Model:false,

      client_group_ids: '',
      stop_name: "",
      route_name: "",
      person_name: "",
      person_mobile: "",
      show: false,
      set_loading: false,
      compliant_id: "",
      compliant_by: "",
      mobile_no: "",
      village_code: "",
      district_code: "",
      block_code: "",
      village_name: "",
      block_name: "",
      state_name: "",
      showFirstFilter: false,
      complaint_status_get: null,
      complaint_type_get: null,
      client_id_dropdown: [],
      client_id_search: "",
      district_dropdownItems: [],
      district_dropdownItem: null,
      block_dropdownItems: [],
      block_dropdownItem: null,
      panchayat_dropdownItem:null,
      panchayat_dropdownItems:[],
      village_dropdownItems: [],
      village_dropdownItem: null,
      user_key: "",
      place_details: "",
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      icon_dropdown: [],
      service_name: "",
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      parent_selectstatus: { name: "", value: "" },
      pick_icon: { name: "", value: "" },
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: [],
      filters: {},
      offset: 1,
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.user_key = localStorage.getItem("user_key");
    this.client_group_ids = localStorage.getItem('client_group_ids');
    this.initFilters();
    this.get_client_list();
    this.getDistrictData();
    this.getBlockData();
    //this.getVillageData();
    this.showFirstFilter = false;
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
      "Commercial Master",
      "/Commercial_stop_master"
    );
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    async Print_QR_selected() {
            if (this.selectedProducts.length == 0) {
                alert('Please select  atleast one record')
                return false;
            }
            this.printQR_data = [];
            for (let index = 0; index < this.selectedProducts.length; index++) {
                this.printQR_data.push({ data: this.selectedProducts[index] });
            }

            this.print_QR_Model = true;
        },
    generate_QR()
    {
        console.log(this.panchayat_dropdownItem_select);
        
        if (!this.panchayat_dropdownItem_select) 
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Panchyat",
          life: 3000,
        });
        return false;
        }
        if (this.panchayat_dropdownItem_select && this.panchayat_dropdownItem_select.value=='') 
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Panchyat",
          life: 3000,
        });
        return false;
        }
        if (this.qrCount==0 || this.qrCount=='') 
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please enter total no of QR",
          life: 3000,
        });
        return false;
        }
     
        
        var panchayat_dropdownItem_select = this.panchayat_dropdownItem_select.value;

        var data = {
          "qrcount"     :this.qrCount,
          "user_id"     :localStorage.getItem("id"),
          "panchyat_id" :panchayat_dropdownItem_select,
          "stop_type"   :'Commercial',
        }
        this.isLoadingModel = true;
        var promises = apis.stopgenerateqr(data);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            if (response.data.data.status==true) {
              this.generateQRDialog = false;
              this.$swal(response.data.data.message);
              this.get_list();
              this.get_count();
            } else {
              
              this.$swal(response.data.data.message);
              
            }
            
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.generateQRDialog = false;

            this.$swal.fire(response.data.data.message);
            this.get_list();
            this.get_count();
          });



    },
    GenerateQr()
    {
      this.product = {};
      this.submitted = false;
      this.qrCount='';
      this.client_id_search="";
      this.generateQRDialog = true;
    },
    async downloadQr()
    {
      var canvas = await document.getElementById("qrprint");
      var anchor = document.createElement("a");
      anchor.href = canvas.toDataURL("image/png");
      anchor.download = "QrIMAGE.PNG";
      anchor.click();
    },
    async print_Qr()
    {


      const pdf = new jsPDF();

      for (let i = 0; i < this.printQR_data.length; i++) {
        const result = this.printQR_data[i];

        const routeNameText = `Route Name: ${result.data.route_name}`;
        const stopNameText = `Stop Name: ${result.data.stop_name}`;

        // Calculate text width to determine if it fits on the page
        const routeNameTextWidth = pdf.getTextWidth(routeNameText);
        const stopNameTextWidth = pdf.getTextWidth(stopNameText);

        if (stopNameTextWidth > 100) {
          // If the stop name text is too wide, reduce the font size
          pdf.setFontSize(10);
        }

        pdf.text(routeNameText, 10, 10);
        pdf.text(stopNameText, 10, 25);
        
        const canvas = document.getElementById('qrprint_' + result.data.uicode);
        const dataUrl = canvas.toDataURL("image/png");

        // Add QR Code image to the PDF
        pdf.addImage(dataUrl, "PNG", 10, 40, 100, 100);

        // Add a new page for each QR code except the last one
        if (i < this.printQR_data.length - 1) {
          pdf.addPage();
        }
      }

      // Save or display the PDF
      pdf.save("QR.pdf");
      // or display the PDF in a new tab
      // pdf.output('dataurlnewwindow');
    
     
   
    },
    async printQr()
    {
         var dataUrl = await document.getElementById('qrprint').toDataURL(); //attempt to save base64 string to server using this var  
    var windowContent = await '<!DOCTYPE html>';
    windowContent += await '<html>'
    windowContent += await '<head><title>'+this.print_route_name+'('+this.print_stop_name+')</title></head>';
    windowContent +=await '<body>'
    windowContent +=await '<h4> Route Name: '+this.print_route_name+'</h4>';
    windowContent +=await '<h4> Stop Name: '+this.print_stop_name+'</h4><br>';
    windowContent += await '<img src="' + dataUrl + '">';
    windowContent +=await '</body>';
    windowContent +=await '</html>';
    var printWin = window.open('','','width=900,height=600,align=center');
    // alert(windowContent);
    await printWin.document.open();
    await printWin.document.write(await windowContent);
    printWin.document.close();
    printWin.focus();
    printWin.print();
    // printWin.close();
    },
    showQr(product) {
      this.qrcodevalue=product.uicode;
      this.print_stop_name=product.stop_name;
      this.print_route_name=product.route_name;
      this.qrCodetDialog=true;
      
    },
    async update_complaint() {
      if (this.product._id) {
        if (this.complaint_status_get && this.complaint_status_get.value == '') {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Complaint Status Error!!!",
            life: 3000,
          });
          return false;
        }
        if (this.product.remark == '') {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Remark Error!!!",
            life: 3000,
          });
          return false;
        }
        var data = {
          "complaint_id": this.product._id,
          "user_id": localStorage.getItem("id"),
          "complaint_status": this.complaint_status_get.value,
          "remark": this.product.remark
        };
        this.isLoadingModel = true;
        var promise = apis.updateComplaintStatus(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },
    get_village(search) {
      var district_code = [];
      var block_code = [];
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      var data = {
        "count": false,
        "page_no": 1,
        "limit": 10,
        "search_name": search.value,
        district_code: district_code,
        block_code: block_code,
      };
      var promise = apis.getVillageData(data);
      promise.then((response) => {
        this.village_dropdownItems = [];
        var temp = response.data.data;
        for (let a = 0; a < temp.length; a++) {
          this.village_dropdownItems.push({ name: temp[a].village_name, value: temp[a].village_code });
        }
      });
    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;
        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return year + "-" + month + "-" + date;
          }
        }
      }
      else {
        return "";
      }
    },
    show_filter() {
      this.showFirstFilter = true;
    },
    get_client_list() {
      var data = { count: false };
      var promise = apis.getclientist(data);
      promise.then((response) => {
        if (response.data.data) {
          response.data.data
            .filter((item) => item.client_name)
            .map((item) =>
              this.client_id_dropdown.push({
                name: item.client_name,
                code: item._id,
              })
            );
        }
      });
    },
    string_to_array_converter(str) {
      if (str) {
        var substrings = str.split(",");
        var strArray = substrings.map(function (substring) {
          return parseFloat(substring.trim());
        });
        return strArray;
      } else {
        return [];
      }
    },
    getDistrictData() {
      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        client_id: client_id,
        count: false,
      };
      var promise = apis.getStateData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.district_dropdownItem = null;
          this.district_dropdownItems = temp_data;
          if (
            this.district_dropdownItems.length > 0 &&
            localStorage.getItem("district_id")
          ) {
            var data = this.district_dropdownItems;
            var temp_district_id = this.string_to_array_converter(
              localStorage.getItem("district_id")
            );
            const valuesFromArr1 = new Set(temp_district_id);
            const filteredArr2 = data.filter((obj) =>
              valuesFromArr1.has(obj.value)
            );
            this.district_dropdownItems = filteredArr2;
          }
        }
      });
    },
    getBlockData() {
      this.block_dropdownItem = null;
      this.block_dropdownItems = [];
      var district_code = [];
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      this.set_loading = true;
      var data = {
        district_code: district_code,
        count: false,
      };
      var promise = apis.getBlockData(data);
      promise.then((response) => {
        this.set_loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.block_dropdownItem = null;
          this.block_dropdownItems = temp_data;
          if (
            this.block_dropdownItems.length > 0 &&
            localStorage.getItem("block_id")
          ) {
            var data = this.block_dropdownItems;
            var temp_block_id = this.string_to_array_converter(
              localStorage.getItem("block_id")
            );
            const valuesFromArr1 = new Set(temp_block_id);
            const filteredArr2 = data.filter((obj) =>
              valuesFromArr1.has(obj.value)
            );
            this.block_dropdownItems = filteredArr2;
          }
        }
      });
    },

    // getPanchayatData2()
    // {
    //   this.panchayat_dropdownItem=null;
    //   this.panchayat_dropdownItems=[];

    //   var district_code=[];
    //   var block_code=[];

    //   if(this.district_dropdownItem)
    //   {
    //     for(var i=0;i<this.district_dropdownItem.length;i++)
    //     {
    //       district_code.push(this.district_dropdownItem[i].value);
    //     }
    //   }
    //   if(this.block_dropdownItem)
    //   {
    //     for(var j=0; j<this.block_dropdownItem.length;j++)
    //     {
    //       block_code.push(this.block_dropdownItem[j].value);
    //     }
    //   }

    //   var data=[{
    //     district_code:district_code, block_code:block_code, count:false,
    //   }];
    //   var promise=apis.getPanchayatData(data);
    //   promise.then((response)=>{
    //     if(response.data.data)
    //     {

    //     }
    //   })
      
      
    // },

    getPanchayatData(search)
    {
      this.panchayat_dropdownItem=null;
      this.panchayat_dropdownItems=[];
      
      var district_code=[];
      var block_code=[];
      if(this.district_dropdownItem)
      {
        for(var i=0;i<this.district_dropdownItem.length;i++)
        {
          district_code.push(this.district_dropdownItem[i].value);
        }
      }

      if(this.block_dropdownItem)
      {
        for(var i=0;i<this.block_dropdownItem.length;i++)
        {
          block_code.push(this.block_dropdownItem[i].value);
        }
      }
      var search_key='';
      if (search && search!='') {
        search_key = search;
      }
      var data={
        district_code:district_code,
        block_code:block_code,
        count:false,
        search_key:search_key
      };
      var promise=apis.getPanchayatData(data);
      promise.then((response)=>{
        if(response.data.data){
          var temp_data=[];
          for(let x=0;x<response.data.data.length;x++)
          {
            temp_data.push({
              name:response.data.data[x]['Local Body Name'],
              value:response.data.data[x]['Local Body Code']
            });
          }
          this.panchayat_dropdownItem=null;
          this.panchayat_dropdownItems=temp_data;
        }
      });
    },

    getVillageData() {
      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        //client_id: client_id,
        count: false,
        service_name: "",
        limit: "",
        page_no: ""
      };
      var promise = apis.getVillageData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].village_name,
              value: response.data.data[x].code,
            });
          }
          this.village_dropdownItem = null;
          this.village_dropdownItems = temp_data;
        }
      });
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    reset() {
     
      this.client_id_search = "";
        this.service_name = "";
        this.showFirstFilter = false;
        this.compliant_id = "";
        this.compliant_by = "";
        this.mobile_no = "";
        this.stop_name = "";
        this.route_name = "";
        this.person_name = "";
        this.person_mobile = "";
        this.village_dropdownItem = null;
        this.block_dropdownItem = null;
        this.district_dropdownItem = null;
     
       this.get_list();
      this.get_count();

      
    },
    async search(count) {
      if (count == 2) {
        this.client_id_search = "";
        this.service_name = "";
        this.showFirstFilter = false;
        this.compliant_id = "";
        this.compliant_by = "";
        this.mobile_no = "";
        this.stop_name = "";
        this.route_name = "";
        this.person_name = "";
        this.person_mobile = "";
        this.village_dropdownItem = null;
        this.block_dropdownItem = null;
        this.district_dropdownItem = null;
        await this.getDistrictData();
        await this.getBlockData();
        //await this.getVillageData();
      }
      await this.get_list();
      await this.get_count();
    },
    async viewProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.show = false;
      this.complaint_type_get = { name: "", value: "" };
      this.complaint_status_get = { name: "", value: "" };
      this.product.complaint_date = this.dateFormatDMY(this.product.complaint_date);
      this.complaint_status_get.name = this.product.complaint_status_name;
      this.complaint_status_get.value = this.product.complaint_status;
      this.complaint_type_get.name = this.product.complaint_type_name;
      this.complaint_type_get.value = this.product.complaint_type;
      //this.product.remark="";
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.show = this.product.complaint_status == 4 ? false : true;  //4-closed
      this.complaint_type_get = { name: "", value: "" };
      this.complaint_status_get = { name: "", value: "" };
      this.product.complaint_date = this.dateFormatDMY(this.product.complaint_date);
      this.complaint_status_get.name = this.product.complaint_status_name;
      this.complaint_status_get.value = this.product.complaint_status;
      this.complaint_type_get.name = this.product.complaint_type_name;
      this.complaint_type_get.value = this.product.complaint_type;
      this.product.remark = "";
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
      var client_group_ids = [];
      if (localStorage.getItem('client_group_ids')) {
        client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
      }
      else {
        client_group_ids.push(localStorage.getItem('client_id'));
      }
      var block_code = [];
      var district_code = [];
      var village_code = [];
      var panchayat_code=[];
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
          panchayat_code.push(this.panchayat_dropdownItem[f].value);
        }
      }
      if (this.village_dropdownItem) {
        for (var e = 0; e < this.village_dropdownItem.length; e++) {
          village_code.push(this.village_dropdownItem[e].value);
        }
      }
      var data = {
        count: true,
        district_code: district_code,
        block_code: block_code,
        panchayat_code:panchayat_code,
        village_code: village_code,
        stop_type: 'Commercial',
        "client_group_ids": client_group_ids,
        client_id: client_id,
        user_id: localStorage.getItem("id"),
        stop_name: this.stop_name,
        route_name: this.route_name,
        person_name: this.person_name,
        person_mobile: this.person_mobile,
      };
      this.loading = true;
      var promise = apis.group_stop_master(data);
      promise.then((response) => {
        this.loading = false;
        //   console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });
      // console.log(data);
    },
    get_list: function () {
      var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
      var client_group_ids = [];
      if (localStorage.getItem('client_group_ids')) {
        client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
      }
      else {
        client_group_ids.push(localStorage.getItem('client_id'));
      }
      var block_code = [];
      var district_code = [];
      var village_code = [];
      var panchayat_code=[];
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.village_dropdownItem) {
        for (var e = 0; e < this.village_dropdownItem.length; e++) {
          village_code.push(this.village_dropdownItem[e].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
          panchayat_code.push(this.panchayat_dropdownItem[f].value);
        }
      }
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        stop_type: 'Commercial',
        district_code: district_code,
        block_code: block_code,
        village_code: village_code,
        panchayat_code:panchayat_code,
        "client_group_ids": client_group_ids,
        client_id: client_id,
        user_id: localStorage.getItem("id"),
        stop_name: this.stop_name,
        route_name: this.route_name,
        person_name: this.person_name,
        person_mobile: this.person_mobile,
      };
      this.loading = true;
      var promise = apis.group_stop_master(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.selectstatus = { name: "", value: "" };
      this.parent_selectstatus = { name: "", value: "" };
      this.pick_icon = { name: "", value: "" };
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },
    deleteservice() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          user_id: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.deleteservicedata(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Role");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: { QrcodeVue },
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";

.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
  